/*
 * Homepage-only gentle fade/drift-in entrance animations. Minimal and
 * understated on purpose — no bounce, no scale, no autoplay carousels.
 * Respects prefers-reduced-motion entirely.
 */
(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (prefersReducedMotion) return;

  // ---- Entrance animations ----
  // Scoped to the "Individual Beers" (featured-collection), "New Beer"
  // (new-beers-marquee), and footer sections per feedback — the rest of
  // the homepage stays still. Section wrapper ids are prefixed with a
  // template/theme-specific string, so match by suffix instead of a
  // hardcoded full id.
  var revealSectionSuffixes = ['__individual_beers', '__new_beers', '__footer'];
  var allSections = document.querySelectorAll('[id^="shopify-section-"]');

  allSections.forEach(function (el) {
    var matches = revealSectionSuffixes.some(function (suffix) {
      return el.id.indexOf(suffix) !== -1;
    });
    if (matches) el.setAttribute('data-bp-reveal', '');
  });

  var targets = document.querySelectorAll('[data-bp-reveal]');
  if (!targets.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bp-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  targets.forEach(function (el) {
    observer.observe(el);
  });
})();
